module.exports = __webpack_public_path__ + "static/media/icon_remove.276f429d.svg";